import { browserTime, dateFormat } from './time';

// Date-only drafts launch through the legacy UTC end-of-day mapping. All other
// API timestamps, including legacy offset-less values, represent UTC instants.
export const offerExpirationTime = (value) => browserTime(
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? `${value}T23:59:59Z`
    : value
);

export const offerExpiration = (value, now = Date.now()) => {
  const end = offerExpirationTime(value);
  if (!end.isValid()) return { label: 'End time not set', daysRemaining: null };

  const milliseconds = end.valueOf() - Number(now);
  const daysRemaining = milliseconds / 86400000;
  let label;
  if (milliseconds <= 0) label = 'Expired';
  else if (milliseconds < 60000) label = 'Ends in less than 1 minute';
  else if (milliseconds < 3600000) {
    const minutes = Math.ceil(milliseconds / 60000);
    label = `Ends in ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  } else if (milliseconds < 86400000) {
    const hours = Math.ceil(milliseconds / 3600000);
    label = `Ends in ${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  } else if (daysRemaining < 14) {
    const days = Math.ceil(daysRemaining);
    label = `Ends in ${days} ${days === 1 ? 'day' : 'days'}`;
  } else label = `Ends on ${end.format(dateFormat)}`;
  return { label, daysRemaining };
};
